<div class="page-content-wrapper">
  <app-sidebar-layout [showMenuToggle]="true">
    <div class="filter-forms-nav pages-title-nav p-0">
      <div class="container-fluid px-4">
        <div class="row align-items-center">
          <div class="calibration-history-title col-xs-12 col-sm-12 col-md-12 col-12 nav-colmn pl-0 ">
            <ul class="page-name-div calibration-name-list d-flex align-items-center">
              <a class="left-arrow" routerLink="/dashboard/devices/calibration-equipment">
                <span class="material-symbols-outlined purple-text pt-1 ">chevron_left</span>
              </a>
              <app-tab-main [links]="tabs"></app-tab-main>
              @if (equipmentIdentifier) {
                <span class="equipment-identifier ml-auto">
                  {{ equipmentIdentifier.label | translate }}: <strong>{{ equipmentIdentifier.value }}</strong>
                </span>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="page-content-inner-wrap card-style-sec calibration-history-page-wrap custom-scrollbar">
      <div class="container-fluid">
        <div class="custom-theme-table tableColStyle without-borders-table">
          <div class="table-responsive custom-scrollbar">
            <table mat-table class="table table-stripes" [dataSource]="dataSource" matSort
              (matSortChange)="onSortChange($event)" [matSortDirection]="defaultOrderBy"
              [matSortActive]="sortActive" matSortDisableClear>

              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                  @if (isLoading) {
                    <ng-container class="loader-container">
                      <app-rings-loader></app-rings-loader>
                    </ng-container>
                  }
                  @if (!isLoading) {
                    {{'No data matching the filter' | translate}}
                  }
                </td>
              </tr>
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                <td mat-cell *matCellDef="let element">{{ element.id}}</td>
              </ng-container>

              <ng-container matColumnDef="calibrationDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{'Calibration Date' | translate}}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.calibrationDate | dateFormat }}
                </td>
              </ng-container>

              <ng-container matColumnDef="nextCalibrationDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{'Next Calibration Date' | translate}}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.nextCalibrationDate | dateFormat }}
                </td>
              </ng-container>

              <ng-container matColumnDef="calibrationStatus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{'Status' | translate}}
                </th>
                <td mat-cell *matCellDef="let element">
                  <span class="status"
                    [ngClass]="{'pass': $safeNavigationMigration(element?.calibrationStatus), 'fail': !element?.calibrationStatus}">
                    {{ (element?.calibrationStatus ? 'PASS' : 'FAIL') | translate }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="certificateUrl">
                <th mat-header-cell *matHeaderCellDef> {{'Certificate URL' | translate}} </th>
                <td mat-cell *matCellDef="let element"
                  (click)="element.certificateUrl && openUrl(element.certificateUrl)"
                  [ngClass]="element.certificateUrl ? 'cursor-pointer' : ''">
                  {{ (element.certificateUrl? 'Certificate Link' : 'No Certificate') | translate }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; let even = even;
                            columns: displayedColumns;" [class.even-row]="even"> </tr>
            </table>
          </div>
          <div class="paginator-container">
            <mat-paginator [length]="totalItems" [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
            [pageIndex]="pageIndex" (page)="onPageChange($event)"></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </app-sidebar-layout>
</div>